module.exports = __webpack_public_path__ + "img/ec.c5c9c153.png";